module.exports = __webpack_public_path__ + "static/instagram-48488ace3f890330c9158247700b04e9.jpg";